"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledValueNumber = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledValueNumber = (0, styled_components_1.default)(ui_components_1.Typography) `
  color: ${ui_components_1.baseColors.primaryGreen300};
  font-size: 0.75rem;
`;
